<template>
  <div class="card p-4 radius">
    <b-modal ref="surveyModal" id="surveyModal" :title="$t('file-approval-survey.status')" scrollable size="xl" title-class="font-18" v-model="show">
      <survey-question-set-answering />

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="success" icon="mdi mdi-check" size="sm" buttonClass="ml-2">
            {{ $t("common.ok") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
    <div class="mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center" style="gap: 2.34rem;">
        <div>
          <!-- <h1 class="title">{{ header }}</h1> -->
          <h1 class="title">{{ survey.name | translate }}</h1>
        </div>
      </div>
      <div v-if="survey">
        <sweet-button
          v-if="survey.status != 'DONE'"
          @click="completeSurvey()"
          type="submit"
          :disabled="!allowedToComplete"
          variant="success"
          icon="mdi mdi-check"
          size="sm"
          buttonClass="mt-2"
        >
          {{ $t("file-approval-survey.complete") }}
        </sweet-button>
      </div>
    </div>
    <table class="table custom-table">
      <thead>
        <tr>
          <th class="text-center" rowspan="2">{{ $t("file-approval-survey.member.text") }}</th>

          <!-- <th class="text-center ">{{ $t("file-approval-survey.status") }}</th> -->
          <th class="text-center ">{{ $t("file-approval-survey.response") }}</th>
          <th class="text-center ">{{ $t("common.at") }}</th>
          <th class="text-center "></th>
        </tr>
      </thead>
      <tbody v-if="resultsPagination">
        <tr v-for="result in resultsPagination.docs">
          <td class="text-center">
            <span v-if="result.participant.assignee">
              {{ result.participant.assignee.name }}
            </span>
          </td>
          <!-- <td class="text-center">
            <span
              :class="{
                'bg-success text-white': result.status === 'DONE',
                'bg-danger text-white': result.status === 'REJECTED',
                'bg-main text-white': result.status === 'IN_PROGRESS',
              }"
              class="badge badge-light border border-secondary p-1"
              >{{ displayStatus(result.status) }}</span
            >
          </td> -->
          <td class="text-center">
            <span v-if="result.questionSet.rating && result.questionSet.completed">
              {{ result.questionSet.rating | translate }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="text-center">{{ answeredAt(result) }}</td>
          <td>
            <div class="text-center">
              <button @click="showResult(result)" class="btn btn-sm btn-main mr-2">
                {{ $t("file-approval-survey.view") }}
              </button>
              <button v-if="result.status != 'DONE' || survey.status != 'DONE'" @click="reject(result)" class="btn btn-sm btn-primary mr-2">
                {{ $t("file-approval-survey.reject") }}
              </button>
              <!-- <button v-if="result.status != 'DONE'" @click="approve(result)" class="btn btn-sm btn-success">{{ $t("file-approval-survey.approve") }}</button> -->
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="11"></td>
        </tr>
      </tbody>
    </table>
    <div style="height:300px"></div>
  </div>
</template>

<script>
import SurveyQuestionSetAnswering from "./component/survey-question-set-answering.vue";
export default {
  components: { SurveyQuestionSetAnswering },

  data() {
    return {
      show: false,
      request: {
        options: { page: 1, limit: 200 },
        query: {},
      },
    };
  },
  async mounted() {
    await this.init();
  },
  watch: {},
  computed: {
    resultsPagination() {
      return this.$store.getters[`organizationFileApprovalSurvey/resultsPagination`];
    },
    file() {
      return this.$store.getters["fileManager/selectedEntity"];
    },
    survey() {
      return this.$store.getters["organizationFileApprovalSurvey/survey"];
    },
    allowedToComplete() {
      const results = this.resultsPagination?.docs;
      if (!results) return false;

      return results.length > 0 && results.every((i) => i.questionSet?.score > 0);
    },
    header() {
      // return this.$t("file-approval-survey.result-page-header", { no: this.file?.no, name: this.$options.filters.translate(this.file?.name) });
    },
  },

  methods: {
    answeredAt(result) {
      const date = result?.questionSet?.questions?.[0]?.updatedAt;
      const completed = result?.questionSet?.completed;
      return date && completed ? this.$options.filters.date(date, true) : "";
    },
    async showResult(result) {
      this.show = true;
      await this.$store.dispatch("organizationQuestionSet/findById", result.questionSet._id);
    },

    goBack() {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${this.file?._id}/survey`);
    },
    async init() {
      const fileId = this.$route.params.fileId;
      const surveyId = this.$route.params.surveyId;

      const file = await this.$store.dispatch("fileManager/fetchDetail", fileId);

      this.$store.commit("fileManager/selectedEntity", file);

      await this.$store.dispatch("organizationFileApprovalSurvey/fetchSurveyDetail", surveyId);

      await this.fetchSurveyResults();
    },
    // displayStatus(status) {
    //   if (status == "DONE") {
    //     return "Onaylandı";
    //   } else if (status == "REJECTED") {
    //     return "Tekrar Gönderildi";
    //   } else if (status == "IN_PROGRESS") {
    //     return "Devam Ediyor";
    //   }
    // },
    async reject(payload) {
      try {
        await this.$store.dispatch("organizationFileApprovalSurvey/reSend", payload._id);
        await this.fetchSurveyResults();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    // async approve(result) {
    //   try {
    //     const payload = {
    //       id: result._id,
    //       status: "DONE",
    //     };
    //     await this.$store.dispatch("organizationFileApprovalSurvey/update", payload);
    //     await this.fetchSurveyResults();
    //     this.$toast.success(this.$t("common.success"));
    //   } catch (error) {
    //     this.$handleHttpErrorByStatusCode(error);;
    //   }
    // },
    async completeSurvey() {
      try {
        if (!this.resultsPagination || !this.resultsPagination.docs) {
          return;
        }
        const results = this.resultsPagination.docs;

        const check = results.length == 0 || results.some((i) => i.score == 0);

        if (check) {
          this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("file-approval-survey.alert.complete") });
          return;
        }

        await this.$store.dispatch("organizationFileApprovalSurvey/completeSurvey", this.survey._id);
        this.$toast.success(this.$t("common.success"));
        setTimeout(() => {
          this.goBack();
        }, 1000);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async fetchSurveyResults() {
      try {
        await this.$store.dispatch("organizationFileApprovalSurvey/fetchResults", this.survey._id);
      } catch (error) {
        console.log(error);

        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
